import { mapGetters } from 'vuex';
import { TrackerProductObject, TrackerCartAdd } from '@/Scripts/lib/helper/trackingHelper.js';
import { eventBus } from '@/Scripts/lib/helper/eventBus.js';
import toastMixin from '@/Scripts/lib/mixins/toastMixin.js';

export default {
  mixins: [toastMixin],
  data () {
    return {
      mixin_addToBag_adding: false,
      mixin_addToBag_viewOverlay: false,
      mixin_addToBag_viewOverlay_disabled: false,
      mixin_addToBag_enableToast: false
    };
  },
  watch: {
    mixin_addToBag_cartCount: function (newvalue, oldvalue) {
      // finish add to bag when cart count is increased
      if (this.mixin_addToBag_adding && newvalue > oldvalue) {
        this.mixin_addToBag_adding = false;
        if (!this.mixin_addToBag_viewOverlay_disabled) {
          this.mixin_addToBag_viewOverlay = true;
          eventBus.$emit('on-added-to-bag');
        }
        if (this.mixin_addToBag_enableToast) {
          this.$_toast_add('', this.insertString('Product', 'ProductAddedToBag'), 'success', null);
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      mixin_addToBag_cartCount: 'bag/cartCount'
    })
  },
  methods: {
    mixin_addToBag_add (addType, variantObj, sizeObj) {
      TrackerCartAdd(TrackerProductObject({
        product: this.model,
        colorVariant: variantObj,
        size: sizeObj ? sizeObj.Size : '',
        outlet: this.outlet,
        pageType: this.$root._vnode.tag.replace(/vue-component-\d*-/, '').trim(),
        addToCartType: addType
      }), this.listName);
      this.$store.dispatch('bag/addCartItems', { sku: sizeObj.Sku, listName: this.listName });
      this.mixin_addToBag_adding = true;
    }
  }
};
